import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { map } from 'rxjs';
import { UserSyncService } from '../resolvers/user-data.resolver';

// Runs sync-access (once, shared via UserSyncService) before the Terms check.
export const userInitGuard: CanActivateFn = () =>
  inject(UserSyncService).load().pipe(map(() => true));
